import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Select from 'react-select';
import { connect } from 'react-redux';

import moment from 'moment';
import { 
  FormItem,
  Search
} from 'carbon-components-react';
import {Breadcrumb, TableDefault, Tabs, DatePicker} from '../../../components/index';
import { getDmService } from '../../../services/Api';
import actions from '../../../redux/modules/user';
import mainActions from '../../../redux/modules/main';
import { Consultor, Criacao, Interno } from '../../../config/UserStatusLevel';


class ListRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      
      user: JSON.parse(localStorage.getItem('user')) || { nivel: {} },
      page: 1,
      listFilters: [
        {title: "Agência", location: "agencia", badge: 0},
        {title: "Comunicação", location: "comunicacao", badge: 0},
        /* {title: "Trade", location: "trade", badge: 0} */
      ],
      comunication:false, 
      trade:false,
      agency: false,
      statusSelected:"", 
      actionPending: false,
      listStatus: [],     
      params: "",
      statusId: 0,
      updateLocation: "",
      search: "",
      dataInicio: "",
      dataFim: ""
    }
  }

  componentWillMount = async () => {
    const {loadCounters} = this.props;
    await this.updateListStatus(this.props);
    await this.getStatus();
    loadCounters()
  }

  componentWillReceiveProps = async (receivProps) => {
    const {location} = receivProps
    const {pathname} = location
    const {updateLocation} = this.state;
    await this.updateListStatus(receivProps);
    
    if(pathname !== updateLocation){
      
      this.setState({
        params: "",
        updateLocation: pathname,
        statusSelected: "",
        statusId: 0,
        listStatus: []
      }, async () => {
        this.updateParams();       
      });


    }

  }

  changeDateInit = (date) => {
    this.setState({ dataInicio: date }, () => {
      this.updateParams();
   });

    this.updateListStatus(this.props);
  }
  
  changeDateFinish = (date) => {
    this.setState({ dataFim: date }, () => {
      this.updateParams();
   });

    this.updateListStatus(this.props);
  }

  onSearchChange =  data => {   
    this.setState({
      search: data.target.value === undefined ? "" : data.target.value
    }, async () => {      
      await this.updateListStatus(this.props);
    })
  }


  updateListStatus = async props => {
    const {location}= props;    
    const currentURl = await location.pathname;
    const urlVisited = await currentURl.split('/')[2];
    const {search} = this.state;

    const newSearch = search === undefined || search === null ? "" : search
    if (urlVisited === "agencia") {
      await this.setState({
        agency: true,
        trade: false,
        comunication: false,
        urlDelete: '/ModeloCategoria/Delete/',
        urlEdit: '/admin/agencia/pedido/',
        urlLoad: '/Usuario/MeusPedidosv2/',
        urlVisited,
        pageSize: 100,
        totalItems: 0,
        orderBy: 'solicidato',
        order: 'desc',
        search: newSearch
      });
    }else  if (urlVisited === "comunicacao") {
      await this.setState({
        agency: false,
        trade: false,
        comunication: true,
        urlDelete: '/ModeloCategoria/Delete/',
        urlEdit: '/pedido/comunicacao/campanha/',
        urlLoad: '/Usuario/MeusPedidosv2/',
        urlVisited,
        pageSize: 100,
        totalItems: 0,
        orderBy: 'solicidato',
        order: 'desc',
        statusSelected: ''
      });
    }else {
      await this.setState({
        agency: false,
        trade: true,
        comunication: false,
        urlDelete: '/ModeloCategoria/Delete/',
        urlEdit: '/admin/trade/pedido/',
        urlLoad: '/Usuario/MeusPedidosv2/',
        urlVisited,
        pageSize: 100,
        totalItems: 0,
        orderBy: 'solicidato',
        order: 'desc',
        statusSelected: ''
      });
    }

    await this.updateParams();

  }

  updateParams =  () => {
    const {
      search,
      dataInicio,
      dataFim,
      comunication,
      trade,
      statusId,
      actionPending,
      urlVisited,
      agency
    } = this.state;

    const initDate = dataInicio !== "" ? moment(dataInicio).format("YYYY-DD-MMM") : "";
    const finishDate = dataFim !== "" ? moment(dataFim).format("YYYY-DD-MMM") : "";
    let urlCurrent = "";
    if(urlVisited){
      
      if(agency){     
        urlCurrent = ""
        urlCurrent += `${urlCurrent}busca=${search}&dataInicio=${initDate}&dataFim=${finishDate}&comunicacao=${comunication}&agencia=${agency}&trade=${trade}&status=${statusId}&pendenteAcao=${actionPending}`;
        this.getStatus();
      }else if(trade){
        urlCurrent = ""
        urlCurrent += `${urlCurrent}busca=${search}&dataInicio=${dataInicio}&dataFim=${dataFim}&comunicacao=${comunication}&agencia=${agency}&trade=${trade}&status=${statusId}&pendenteAcao=${actionPending}`;
        this.getStatus();
      }else{
        urlCurrent = ""
        urlCurrent += `${urlCurrent}busca=${search}&dataInicio=${dataInicio}&dataFim=${dataFim}&comunicacao=${comunication}&agencia=${agency}&trade=${trade}&status=${statusId}&pendenteAcao=${actionPending}`;
        this.getStatus();
      }
      
      this.setState({
        params: urlCurrent,        
      }, async () => {       
         await this.tableList.getItems();
      })
    }   
  }

  getStatus = async () => {
    const {agency, trade} = this.state;
 
    try {
      let data = null;
      if(agency){
         data = await getDmService(`/Pedido/GetStatus/?tipo=1`);
      }else if(trade){
         data = await getDmService(`/Pedido/GetStatus/?tipo=3`);
      }else{
        data = await getDmService(`/Pedido/GetStatus/?tipo=2`);
      }
            
      if(data.length){
        const listStatus = data.map(item => ({id: item.id, label: item.nome}));
        this.setState({
          listStatus: [{id:0, label: "Todos Status"}, ...listStatus]
        })
      }
    } catch (error) {
      console.log(error);
    }
  }

  setPendingAction = () => {
    this.setState(prevState => ({
      actionPending: !prevState.actionPending
    }), () => {
      this.updateParams();
    })
  }

  onChangeStatus = event => {
    if(event){
      this.setState({
        statusSelected: event,
        statusId: event.id
      }, () => {
        this.updateParams()
      })
    }
  }

  onChangeText = (event) => {
    const { target } = event;
    const { value, id } = target;
    
    this.setState({
      [id]: value
    });
  }

  urlGo = row => {
    const {history} = this.props;
    const {cells} = row;
    const {value:section} = cells[2];
    console.log("section", section);
    if(section === "Brindes"){
      history.push(`/admin/trade/brinde/${row.id}/todos`);
    }else if(section === "Campanha Promocional"){     
      history.push(`/trade/campanhas-promocionais/visualizar/${row.id}`);
    }else if(section === "Prancheta"){
      history.push(`/trade/admin/pranchetas/editar/${row.id}`);
    }else if(section === "Uniforme"){
      history.push(`/trade/admin/uniformes/editar/${row.id}`);
    }else{
      return false;
    }

    return null

  }

  urlGoAgency = row => {
    const {history} = this.props;
    const {cells} = row;
    const section = cells.find(p=>p.info.header === "status").value.split(":")[0];
    if(section === "Pré-Cadastro"){
      history.push(`/pre-cadastro/${row.id}`);
    }else{
      history.push(`/admin/agencia/pedido/${row.id}`);
    }
  }

  render() {
    const {
      pageSize,
      totalItems,
      orderBy,
      order,
      urlDelete,
      urlEdit,
      urlLoad,
      page,
      search,
      listStatus,
      listFilters,
      statusSelected,
      actionPending,
      params,
      agency,
      dataInicio,
      dataFim,
      user
    } = this.state;
    const { match, location } = this.props;

    const notSearch = true;
    const disabled = true;
    const isDesigner = user && user.nivel ? user.nivel.id === Criacao : disabled;
    const isConsulting = user && user.nivel ? user.nivel.id === Consultor : disabled;
    const isInterno = user && user.nivel ? user.nivel.id === Interno: disabled;
    const userRestrict = isConsulting || isDesigner;
    const {pathname} = location



    return (
      <div>
        <Breadcrumb
          title="Pedidos de Agência"
          description="Gerencie os pedidos de produtos"
        />

        <div className="content-wrapper badget-management">
          <div className="bx--row filters-news-requests">
            <div className="bx--col-md-4 bx--col-xs-12 formatedInputField">
              <Search
                className="search-request-agency campoPedido some-class"
                id="search-1"
                name="busca"
                value={search}
                onChange={e => this.onSearchChange(e)}
                labelText="Filtrar tabela"
                placeHolderText="Filtrar tabela"
              />
            </div>

            <div className="bx--col-md-4 bx--col-xs-12 formatedInputField">
              <div className="filter-request-agency">
                <FormItem className="date-init">

                  <label className="bx--label">
                    Data de solicitação
                  </label>

                  <DatePicker
                    id="dataInicioFormatada"
                    date={dataInicio ? moment(dataInicio) : ""}
                    locale="pt"
                    onDateChange={date => this.changeDateInit(date)}
                    placeholder="DD/MM/YYYY"
                    isOutsideRange={() => false}
                    
                  />
                </FormItem>
              </div>
            </div>
            <div className="bx--col-md-4 bx--col-xs-12 formatedInputField">
              <div className="filter-request-agency">
                <FormItem className="date-finish"> 
                  <DatePicker
                    id="dataInicioFormatada"
                    date={dataFim ? moment(dataFim) : ""}
                    locale="pt"
                    onDateChange={date => this.changeDateFinish(date)}
                    placeholder="DD/MM/YYYY"
                    isOutsideRange={() => false}
                    
                  />
                </FormItem>                 
              </div>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-md-12 bx--col-xs-12 tabs-requests formatedInputField">
              <Tabs
                sections={
                  listFilters.map(item => (
                    { title: item.title, path: `${match.url}/${item.location}` }
                  ))
                }
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-md-6 bx--col-xs-12">                          
              <Select
                className="basic-single search-dm label-status-request formatedInputField"
                name="product"
                options={listStatus}
                value={statusSelected}
                onChange={e => this.onChangeStatus(e)}
                placeholder="Digite ou selecione"
                isClearable={false}
                isSearchable
              />
            </div>
            {agency && (
              <div className="bx--col-md-6 bx--col-xs-12">
                <div
                  className={`button-radius-action ${actionPending ? 'button-actions-pading' : 'button-actions-no-pading'}`}
                  onClick={() => this.setPendingAction()
                  }
                >
                  Pendente de Ação
                </div>
              </div>  
            )}
          
          </div>
          {(pathname === "/admin/agencia/pedidos/triagem" && !userRestrict) && (
            <div className="bx--row">
              <div className="bx--col-md-12 bx--col-xs-12">
                <div className="f-right">
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.openMdCriacao()}
                  >
                    Criação
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.openMdDevolv()}
                  >
                    Devolver
                  </button>
                  {/* <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    type="button"
                    onClick={() => this.openAprovComerc()}
                  >
                    Aprovação Comercial
                  </button> */}
                  <button
                    className="bx--btn btn-primary-outlined h-sm-margin"
                    type="button"
                    onClick={() => this.openMdCancel()}
                  >
                    Cancelar
                  </button>                  
                </div>
              </div>
            </div>
          )
          }

          <Route
            path={`${match.url}/agencia`}
            component={() => (
              <div className="tela-pedidos">
                <TableDefault
                  notSearch={notSearch}
                  params={params}
                  search={search}
                  order={order}
                  orderBy={orderBy}
                  page={page}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  urlDelete={urlDelete}
                  urlEdit={urlEdit}
                  urlLoad={urlLoad}
                  onRef={ref => {
                    this.tableList = ref;
                  }}
                  iconAction="pendenteAcao"
                  displayActions={false}
                  urlGo={e => this.urlGoAgency(e)}
                  editException="/pedidos/agencia"
                  isInterno={isInterno}
                />
              </div>
            )}
          />
          <Route
            path={`${match.url}/comunicacao`}
            component={() => (
              <div className="tela-pedidos">
                <TableDefault
                  notSearch={notSearch}
                  params={params}
                  search={search}
                  order={order}
                  orderBy={orderBy}
                  page={page}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  urlDelete={urlDelete}
                  urlEdit={urlEdit}
                  urlLoad={urlLoad}
                  onRef={ref => {
                    this.tableList = ref;
                  }}
                  displayActions={false}
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/trade`}
            component={() => (
              <div className="tela-pedidos">
                <TableDefault
                  notSearch={notSearch}
                  params={params}
                  search={search}
                  order={order}
                  orderBy={orderBy}
                  page={page}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  urlDelete={urlDelete}
                  urlEdit={urlEdit}
                  urlLoad={urlLoad}
                  onRef={ref => {
                    this.tableList = ref;
                  }}
                  displayActions={false}
                  urlGo={e => this.urlGo(e)}
                  editException="/pedidos/trade"
                />
              </div>

            )}
          />          

        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  loadUser() {
    dispatch(actions.receiveUserData());
  },
  loadCounters() {
    return dispatch(mainActions.receiveCounters());
  },
});

const mapStateToProps = state => ({
  user: state.user.data,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListRequest);



// WEBPACK FOOTER //
// ./src/screens/client/requests/ListRequest.js